import React from 'react'
import styled from 'styled-components'

interface Props {
  children?: React.ReactNode
}

const SmallText = ({
  children,
}: Props) => {
  return (
    <CustomText>
      {children}
    </CustomText>
  )
}

export default SmallText

const CustomText = styled.div`
  color: var(--gray);
  font-size: 12;
`
